module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_table_aut",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Abbreviations")])]), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _c('col', {
    staticStyle: {
      "padding": "7px"
    }
  })]), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("AT")])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Author’s translation.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("BAGD")])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Bauer, Walter. "), _c('i', [_vm._v("A Greek-English Lexicon of the New Testament and Other Early Christian Literature")]), _vm._v(". Revised and augmented by W. F. Arndt, F. W. Gingrich, and F. W. Danker. Chicago: University of Chicago Press, 1979.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("CD ")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Barth, Karl. "), _c('i', [_vm._v("Church Dogmatics")]), _vm._v(". 4 vols., 13 parts. Edited by Geoffrey W. Bromiley and Thomas F. Torrance. Edinburgh: T&T Clark, 1936–1969.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("CF ")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Schleiermacher"), _c('i', [_vm._v(",")]), _vm._v(" Friedrich D. E."), _c('i', [_vm._v(" Christian Faith")]), _vm._v(". 2 vols. Edited by C. L. Kelsey and T. N. Tice. Translated by T. N. Tice, C. L. Kelsey, and E. Lawler. Louisville: Westminster John Knox Press, 2016.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Cl. "), _c('i', [_vm._v("I Cor. ")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("First Letter of Clement, in "), _c('i', [_vm._v("Ante-Nicene Fathers")]), _vm._v(". Vol. 1. Edited by A. Roberts and J. Donaldson. Grand Rapids: Eerdmans, 1979.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("CO")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("Ioannis Calvini opera quae supersunt omnia")]), _vm._v(". Edited by G. W. Baum, E. Cunitz, and E. Reuss. 59 vols. "), _c('i', [_vm._v("Corpus Reformatorum")]), _vm._v(". Brunswick: CA Schwetschke & Son, 1863–1900.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("C-Rom1 ")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Calvin, John. "), _c('i', [_vm._v("Commentaries on the Epistle of Paul the Apostle to the Romans")]), _vm._v(". Edited and translated by J. Owen. Edinburgh: Calvin Translation Society, 1849.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("C-Rom2 ")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Calvin, John. "), _c('i', [_vm._v("Commentary on Romans")]), _vm._v(", Library of Christian Classics. Vol. 23. Edited and translated by J. Haroutunian. Philadelphia: Westminster Press, 1958.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("DBWE")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Bonhoeffer, Dietrich. "), _c('i', [_vm._v("Dietrich Bonhoeffer Works in English")]), _vm._v(". 17 vols. Edited by Wayne Whitson Floyd Jr. Minneapolis: Fortress Press, 1995–2011.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("Did.")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("Didache")]), _vm._v(", in "), _c('i', [_vm._v("Ante-Nicene Fathers")]), _vm._v(". Vol. 1. Edited by A. Roberts and J. Donaldson. Grand Rapids: Eerdmans, 1979.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("Epistles")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Cyprian of Carthage. "), _c('i', [_vm._v("The Epistles of Cyprian")]), _vm._v(", in "), _c('i', [_vm._v("Ante-Nicene Fathers")]), _vm._v(". Vol. 5. Edited by A. Roberts and J. Donaldson. Grand Rapids: Eerdmans, 1978.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("ET")])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("English translation.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("GD")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Barth, Karl. "), _c('i', [_vm._v("The Göttingen Dogmatics: Instruction in the Christian Religion")]), _vm._v(". Vol. 1. Edited by H. Reiffen. Translated by G. W. Bromiley. Grand Rapids: Eerdmans, 1990.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XII",
      "title": "XII"
    }
  }, [_c('i', [_vm._v("Hom. On Eph. ")])])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Chrysostom, John. "), _c('i', [_vm._v("Homilies on the Epistle of St. Paul the Apostle to the Ephesians")]), _vm._v(", in "), _c('i', [_vm._v("Nicene and Post-Nicene Fathers")]), _vm._v(". First Series, vol. 13. Edited by P. Schaff. Grand Rapids: Eerdmans, 1979.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Ign. "), _c('i', [_vm._v("Eph.")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Ignatius of Antioch. "), _c('i', [_vm._v("Letter to the Ephesians")]), _vm._v(", in "), _c('i', [_vm._v("Ante-Nicene Fathers")]), _vm._v(". Vol. 1. Edited by A. Roberts and J. Donaldson. Grand Rapids: Eerdmans, 1979.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Ign. "), _c('i', [_vm._v("Mag")]), _vm._v(".")])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Ignatius of Antioch. "), _c('i', [_vm._v("Letter to the Magnesians")]), _vm._v(", in "), _c('i', [_vm._v("Ante-Nicene Fathers")]), _vm._v(". Vol. 1. Edited by A. Roberts and J. Donaldson. Grand Rapids: Eerdmans, 1979.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Ign. "), _c('i', [_vm._v("Phil.")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Ignatius of Antioch. "), _c('i', [_vm._v("Letter to the Philadelphians")]), _vm._v(", in "), _c('i', [_vm._v("Ante-Nicene Fathers")]), _vm._v(". Vol. 1. Edited by A. Roberts and J. Donaldson. Grand Rapids: Eerdmans, 1979.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Ign. "), _c('i', [_vm._v("Rom.")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Ignatius of Antioch. "), _c('i', [_vm._v("Letter to the Romans")]), _vm._v(", in "), _c('i', [_vm._v("Ante-Nicene Fathers")]), _vm._v(". Vol. 1. Edited by A. Roberts and J. Donaldson. Grand Rapids: Eerdmans, 1979.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Ign. "), _c('i', [_vm._v("Smyr.")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Ignatius of Antioch. "), _c('i', [_vm._v("Letter to the Smyrneans")]), _vm._v(", in "), _c('i', [_vm._v("Ante-Nicene Fathers")]), _vm._v(". Vol. 1. Edited by A. Roberts and J. Donaldson. Grand Rapids: Eerdmans, 1979.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Ign. "), _c('i', [_vm._v("Trall.")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Ignatius of Antioch. "), _c('i', [_vm._v("Letter to the Trallians")]), _vm._v(", in "), _c('i', [_vm._v("Ante-Nicene Fathers")]), _vm._v(". Vol. 1. Edited by A. Roberts and J. Donaldson. Grand Rapids: Eerdmans, 1979.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("Inst ")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Calvin, John. "), _c('i', [_vm._v("Institutes of the Christian Religion")]), _vm._v(". Translated by Henry Beveridge. Grand Rapids: Eerdmans, 1989.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("1 Apol. ")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Justin Martyr. "), _c('i', [_vm._v("First Apology")]), _vm._v(", in "), _c('i', [_vm._v("Ante-Nicene Fathers")]), _vm._v(". Vol. 1. Edited by A. Roberts and J. Donaldson. Grand Rapids: Eerdmans, 1979.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("KD")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Barth, Karl. "), _c('i', [_vm._v("Kirchliche Dogmatik")]), _vm._v(". Evangelischer Verlag Zürich, 1938–1965.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Or. "), _c('i', [_vm._v("CC ")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Origen. "), _c('i', [_vm._v("Contra Celsus")]), _vm._v(", in "), _c('i', [_vm._v("Ante-Nicene Fathers")]), _vm._v(". Vol. 4. Edited by A. Roberts and J. Donaldson. Grand Rapids: Eerdmans, 1979.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("Summa")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Aquinas, Thomas. "), _c('i', [_vm._v("Summa Theologiae")]), _vm._v(". The Latin/English Edition of the Works of St. Thomas Aquinas. Translated by L. Shapcote, OP. Edited by J. Mortensen and E. Alarcón. Lander: Aquinas Institute for the Study of Sacred Doctrine, 2012.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Ter. "), _c('i', [_vm._v("Apol. ")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Tertullian. "), _c('i', [_vm._v("Apology")]), _vm._v(", in "), _c('i', [_vm._v("Ante-Nicene Fathers")]), _vm._v(". Vol. 3. Edited by A. Roberts and J. Donaldson. Grand Rapids: Eerdmans, 1978.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('i', [_vm._v("WA ")])])]), _c('td', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Luther, Martin. "), _c('i', [_vm._v("D. Martin Luthers Werke. Kritische Gesamtausgabe (Weimarer Ausgabe)")]), _vm._v(". Weimar: H. Böhlau Nachfolger, 1883–2009.")])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 72
// module chunks = 0